import { ScaleLoader } from "react-spinners";

export default function ButtonLoading({ thisColor = null }) {
  return (
    <div style={{ margin: "0 auto", textAlign: "center" }}>
      <ScaleLoader color={thisColor || "#fff"} height={18} />
    </div>
  );
}
